import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b6dwdx0bqo: FaireBrandEntity = {
  token: "b_b6dwdx0bqo",
  type: "brand",
  name: "Shop Southern Belle",
  avatarUrl:
    "https://cdn.faire.com/fastly/624ae4c2c41950328a1e8a09069c4c421db75286f3577042e674c439c1d6505a.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/2f6afe6e9aff0df52deae5b994b2f5515207cfff79b2179490947c6a441cc419.png",
  logoUrl:
    "https://cdn.faire.com/fastly/624ae4c2c41950328a1e8a09069c4c421db75286f3577042e674c439c1d6505a.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2f6afe6e9aff0df52deae5b994b2f5515207cfff79b2179490947c6a441cc419.png",
  location: "Hendersonville, TN, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 383,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a family owned and operated handmade apparel company specializing in embroidery applique using industrial equipment. We now supply over 10,000 boutiques in the US with our handmade apparel! \n\nJoin our wholesale Facebook group: https://www.facebook.com/groups/1020901722066176/ \n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:22.551Z",
    importedBy: "entity-db-cli",
  },
};
